<ng-container *ngIf="isWorkerView; else adminView">
  <div>
    <span *ngIf="showWeekLabel"
      >{{ 'Week' | translate }}
      <ng-container *ngIf="!(sumHoursLoading$ | async); else loader">
        {{ weekNumber }}
      </ng-container>
      -
    </span>

    <span>{{ 'Hours' | translate }}: </span>

    <ng-container *ngIf="!(sumHoursLoading$ | async); else loader">
      <span>{{ sumHours.get('sum')?.hours || 0 | secondsToPeriod }}/{{ sumHours.get('sum')?.work || 0 | secondsToPeriod }}</span>
    </ng-container>
  </div>
</ng-container>

<ng-template #adminView>
  <div class="hours-sum-row">
    <div class="hours-item-wrapper">
      <span class="user-item-wrapper__label">{{ 'Hours' | translate }}</span>

      <ng-container *ngIf="!(sumHoursLoading$ | async); else loader">
        <span
          >{{ sumHours.get('sum')?.hours || 0 | secondsToPeriod }}/{{ sumHours.get('sum')?.work || 0 | secondsToPeriod }}</span
        >
      </ng-container>
    </div>
    <ng-container *ngIf="!(sumHoursLoading$ | async); else loader">
      <ng-container *ngFor="let date of timesheetDays; trackBy: identifyDay; let i = index">
        <div class="row__item">
          {{ sumHours.get(date?.date)?.hours || 0 | secondsToPeriod }}/{{ sumHours.get(date?.date)?.work || 0 | secondsToPeriod }}
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #loader>
  <span>...</span>
</ng-template>
